export const TRANSACTION_STATUS_TONES = {
  initiated: 'blue',
  pending: 'amber',
  succeeded: 'green',
  failed: 'red',
  expired: 'gray',
  refunded: 'violet',
  unknown: 'gray',
};

/** @deprecated Prefer transactionStatusInfoLocalized(status, t) */
export const TRANSACTION_STATUS_INFO = {
  initiated: { label: 'در حال ایجاد', tone: 'blue' },
  pending: { label: 'در انتظار نتیجه', tone: 'amber' },
  succeeded: { label: 'موفق', tone: 'green' },
  failed: { label: 'ناموفق', tone: 'red' },
  expired: { label: 'منقضی‌شده', tone: 'gray' },
  refunded: { label: 'بازگشت وجه', tone: 'violet' },
  unknown: { label: 'وضعیت نامشخص', tone: 'gray' },
};

/** @deprecated Prefer localized helpers with t() */
export const PAYMENT_MODE_LABELS = {
  product: 'خرید محصول',
  full: 'پرداخت کامل',
  two_stage: 'پرداخت اولیه',
  installments: 'پرداخت مرحله‌ای قدیمی',
  initial: 'پرداخت اولیه قدیمی',
  legacy: 'پرداخت ثبت‌شده',
};

/** @deprecated Prefer localized helpers with t() */
export const PAYMENT_METHOD_LABELS = {
  gateway: 'درگاه بانکی',
  card_to_card: 'کارت‌به‌کارت',
  bank_transfer: 'واریز بانکی',
  cash: 'پرداخت نقدی',
  other: 'پرداخت دستی',
};

export const transactionStatusInfo = (status) => (
  TRANSACTION_STATUS_INFO[status] || TRANSACTION_STATUS_INFO.unknown
);

export const transactionStatusInfoLocalized = (status, t) => ({
  label: t(`customerUi.transactionStatuses.${TRANSACTION_STATUS_INFO[status] ? status : 'unknown'}`),
  tone: TRANSACTION_STATUS_TONES[status] || TRANSACTION_STATUS_TONES.unknown,
});

export const transactionModeLabel = (transaction = {}) => {
  if (transaction.source === 'manual') {
    return PAYMENT_METHOD_LABELS[transaction.paymentMethod] || PAYMENT_METHOD_LABELS.other;
  }
  if (transaction.installmentLabel) return transaction.installmentLabel;
  return PAYMENT_MODE_LABELS[transaction.paymentMode]
    || (transaction.orderType === 'product' ? 'خرید محصول' : 'پرداخت خدمات');
};

export const transactionModeLabelLocalized = (transaction = {}, t) => {
  if (transaction.source === 'manual') {
    return t(`customerUi.transactionMethods.${transaction.paymentMethod}`, {
      defaultValue: t('customerUi.transactionMethods.other'),
    });
  }
  if (transaction.installmentLabel) return transaction.installmentLabel;
  if (transaction.paymentMode) {
    return t(`customerUi.transactionModes.${transaction.paymentMode}`, {
      defaultValue: transaction.orderType === 'product'
        ? t('customerUi.transactionModes.product')
        : t('customerUi.transactionModes.service'),
    });
  }
  return transaction.orderType === 'product'
    ? t('customerUi.transactionModes.product')
    : t('customerUi.transactionModes.service');
};

export const formatTransactionDate = (value, localeCode = 'fa-IR') => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(localeCode, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatTransactionAmount = (amount, localeCode = 'fa-IR') => (
  Number(amount || 0).toLocaleString(localeCode)
);
